var map = {
	"./_0_FOLD_POLTRONA .jpeg": 6346,
	"./_10_Detalle_placa.jpg": 7449,
	"./_11_FOLD_POLTRONA .jpg": 9891,
	"./_1_FOLD CONJUNTO.png": 7352,
	"./_2_Sketches_FOLD .jpg": 7050,
	"./_3_LOGO.png": 4734,
	"./_4_POLTRONA_front .jpg": 6023,
	"./_5_ POLTRONA_TRASERO .jpg": 920,
	"./_6_SOFA_FOLD_.jpg": 5572,
	"./_7_Mesa_FOLD.jpg": 7536,
	"./_8_Detalle_pata.jpeg": 6141,
	"./_9_Detalle_pata.jpg": 2485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6490;